/**
 * Copyright (C) Siemens AG 1996-2024 ALL RIGHTS RESERVED.
 */

import {ChangeDetectionStrategy, Component} from '@angular/core';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {ICellRendererParams} from 'ag-grid-community';

import {RouterModule} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {IxModule} from '@siemens/ix-angular';
import {ShellDescriptor} from '../../../../../models/dpp/shell-descriptor';

@Component({
  selector: 'app-dropdown-cell-renderer',
  standalone: true,
  imports: [RouterModule, TranslateModule, IxModule],
  templateUrl: './dropdown-cell-renderer.component.html',
  styleUrl: './dropdown-cell-renderer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownCellRendererComponent implements ICellRendererAngularComp {
  public params!: ICellRendererParams;
  public shellDescriptor!: ShellDescriptor;
  public isReady = false;

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.shellDescriptor = params.data as ShellDescriptor;

    this.isReady = !!this.shellDescriptor?.id;
  }

  refresh() {
    return false;
  }

  onShowQrClick(): void {
    this.executeAction('qr-code');
  }

  onDeleteClick(): void {
    this.executeAction('delete');
  }

  private executeAction(action: string): void {
    this.params.context?.componentParent?.handleActionClick(
      action,
      this.shellDescriptor,
    );
  }

  get dropdownId(): string {
    return `listPassportItemDropdown.${this.shellDescriptor.id}`;
  }
}
